// extracted by mini-css-extract-plugin
export default {"root":"TesterTermsOfService_root__7H3HT","lastUpdated":"TesterTermsOfService_lastUpdated__IxiPV marketplaceBodyFontStyles"};